// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__2E62x","App__header":"App_App__header__24zuY","App__main":"App_App__main__otDjR","bpk-keyframe-spin":"App_bpk-keyframe-spin__7X606"};